export const CSRF_COOKIE = '__Host-nt_csrf';
export const CSRF_HEADER = 'X-CSRF-Token';

export function readCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const target = `${CSRF_COOKIE}=`;
  const parts = document.cookie.split('; ');
  for (const part of parts) {
    if (part.startsWith(target)) {
      return decodeURIComponent(part.slice(target.length));
    }
  }
  return null;
}
